import { render, staticRenderFns } from "./tord_list.vue?vue&type=template&id=741a9828&scoped=true&"
import script from "./tord_list.vue?vue&type=script&lang=js&"
export * from "./tord_list.vue?vue&type=script&lang=js&"
import style0 from "./tord_list.vue?vue&type=style&index=0&id=741a9828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741a9828",
  null
  
)

export default component.exports